import { DetailsVariant } from "components/entity-details/BaseDetails";
import { BroadcastResponseDetails } from "components/entity-details/BroadcastResponseDetails";
import { Spinner } from "components/spinners/Spinner";
import { useSwitcherClientCore } from "hooks/useSwitcherClient";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addNotification } from "store/notification/slice";
import { NotificationType } from "store/notification/types";
import { AppDispatch } from "store/store";
import { FeaturedVideoType, SelectFeaturedTrailerBaseProps } from ".";

export const FeaturedTrailerInput = ({
    selectedBroadcastId,
    disabled,
    disabledVariant,
    featuredVideoType = FeaturedVideoType.VideoPlayer
}: SelectFeaturedTrailerBaseProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { data: selectedBroadcast, loading } = useSwitcherClientCore(
        (client) => client.broadcasts_GetBroadcastsById,
        {
            requestImmediately: true,
            args: [selectedBroadcastId],
            onError: () => {
                dispatch(
                    addNotification({
                        type: NotificationType.Danger,
                        message: t("errors:recording-retrieval-error")
                    })
                );
            }
        }
    );

    if (loading) {
        return <Spinner />;
    }

    return (
        <BroadcastResponseDetails
            broadcast={selectedBroadcast}
            allowVideoPlaybackOnThumbnailClick={!disabled}
            location={"player-playlist"}
            disabled={disabled}
            disabledVariant={disabledVariant}
            variant={
                featuredVideoType == FeaturedVideoType.Catalog
                    ? DetailsVariant.Vertical
                    : DetailsVariant.Horizontal
            }
        />
    );
};
